import * as React from 'react';
import { post } from '../../../model/post';
import { Grid, Typography, Tooltip } from '@material-ui/core';
import { SendButton } from './SendButton';
import { EditButton } from './EditButton';
import { DeleteButton } from './DeleteButton';
import { WithMediaQuery, IMediaQueryProps } from '../../../layout/withMediaQuery';

interface Iprops extends IMediaQueryProps {
    post: post;
    deliverPost: (post: post) => void;
    getPost: (id: string) => void;
    deletePost: (id: string) => void;
    navigateTo: (path: string) => void;
    classes: any;
}
const fullScreenLayout = (props: Iprops) => {
    const { post, deliverPost, deletePost } = props;
    return (
        <Grid container className={props.classes.listItemContainer}>
            <Grid item xs={1}>
                <div className={props.classes.listPreviewImage}>
                    {post.imagebase64 ? <img alt='' style={{ width: "58px" }} src={post.imagebase64} /> : <></>}
                </div>
            </Grid>
            <Grid item xs={2}>
                <Typography>{post.title}</Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography>{post.description}</Typography>
            </Grid>
            <Grid item xs={1}>
                <Typography>Vote {post.hasYesNoQuestion ? 'Sì' : 'No'}</Typography>
            </Grid>
            <Grid item xs={2} className={props.classes.buttonContainer}>
                <Tooltip title="Pubblica">
                    <span>
                        <SendButton post={post} deliverPost={deliverPost} />
                    </span>
                </Tooltip>
                <EditButton post={post} navigateTo={props.navigateTo} />
                <DeleteButton post={post} deletePost={deletePost} />
            </Grid>
        </Grid>
    );
}

const smallScreenLayout = (props: Iprops) => {
    const { post, deliverPost, deletePost } = props;
    return (
        <Grid container className={props.classes.listItemContainer}>
            <Grid item xs={3}>
                <div className={props.classes.listPreviewImage}>
                    {post.imagebase64 ? <img alt='' style={{ width: "58px" }} src={post.imagebase64} /> : <></>}
                </div>
            </Grid>
            <Grid item xs={9}>
                <div>
                    <Typography>{post.title}</Typography>
                    <Typography>{post.description}</Typography>
                    <Typography>Vote {post.hasYesNoQuestion ? 'Sì' : 'No'}</Typography>
                </div>
            </Grid>
            <Grid item xs={12} className={props.classes.rightAlignedButtons}>
                <Tooltip title="Pubblica">
                    <span>
                        <SendButton post={post} deliverPost={deliverPost} />
                    </span>
                </Tooltip>
                <EditButton post={post} navigateTo={props.navigateTo} />
                <DeleteButton post={post} deletePost={deletePost} />
            </Grid>


        </Grid>
    );
}

const PostItemComp = (props: Iprops) => props.smallScreen ? smallScreenLayout(props) : fullScreenLayout(props)

export const PostItem = WithMediaQuery(PostItemComp)